import * as React from 'react';
import { Fragment, useCallback } from 'react';
import {
    BooleanField, ReferenceField, DateField, TextField, SelectField, FunctionField,
    ReferenceInput, AutocompleteInput, EditButton,
    Datagrid, List,
    useListContext,
    SelectInput,
} from 'react-admin';
import { Divider, Tabs, Tab } from '@mui/material';
import { workerTypeChoices, statusChoices, useGetTotals } from './utils';
import JobShow from './JobShow';

const JobList = () => (
    <List
        filterDefaultValues={{ workerType: workerTypeChoices[0].id }}
        sort={{ field: 'id', order: 'DESC' }}
        perPage={25}
        filters={JobFilters}
        mutationMode="pessimistic"
    >
        <TabbedDatagrid />
    </List>
);

const JobFilters = [
    <ReferenceInput source="submitUserId" key="filter_users" reference="users" alwaysOn>
        <AutocompleteInput
            optionText={choice => choice?.id ? `${choice.name} ${choice.email}` : ''}
            label="User Name or Email"
            sx={{width: 300}}
        />
    </ReferenceInput>,
    <SelectInput source='status' key="filter_status" label='Job Status' choices={statusChoices} alwaysOn />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const { filterValues, setFilters, displayedFilters } = listContext;
    const totals = useGetTotals(filterValues);

    const handleChange = useCallback(
        (_event, value) => {
            setFilters &&
                setFilters(
                    { ...filterValues, workerType: value },
                    displayedFilters,
                    false // no debounce, we want the filter to fire immediately
                );
        },
        [displayedFilters, filterValues, setFilters]
    );

    return (
        <Fragment>
            <Tabs variant="fullWidth" centered
                value={filterValues.workerType} indicatorColor="primary" onChange={handleChange}
            >
                {workerTypeChoices.map(choice => (
                    <Tab key={choice.id} value={choice.id} sx={{textTransform: "none"}}
                        label={totals[choice.id] !== undefined ? `${choice.name} (${totals[choice.id]})` : choice.name}
                    />
                ))}
            </Tabs>
            <Divider />

            <Datagrid rowClick="expand" expand={<JobShow />}>
                <TextField source='name' label='Job Name' />
                <ReferenceField source="submitUserId" reference="users" label="User Name">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="submitUserId" reference="users" label="User Email">
                    <TextField source="email" />
                </ReferenceField>
                <FunctionField label='Queue Time' render={
                    record => ['queued', 'running', 'error', 'success'].includes(record.status) ? 
                        (record.queuingTime > 0 ? <DateField source="queuingTime" showTime /> : '?') : '-'
                    }
                />
               <FunctionField label='Distribute Time' render={
                    record => ['running', 'error', 'success'].includes(record.status) ? 
                        (record.distributeTime > 0 ? <DateField source="distributeTime" showTime /> : '?') : '-'
                    }
                />
                <FunctionField label='Finish Time' render={
                    record => ['error', 'success'].includes(record.status) ? 
                        (record.finishTime > 0 ? <DateField source="finishTime" showTime /> : '?') : '-'
                    }
                />
                <SelectField source='status' label='Job Status' choices={statusChoices} />
                <BooleanField source='public' label='Public' />
                <TextField source='id' label='Job ID' sx={{fontFamily: 'Monospace'}}/>

                <EditButton />
            </Datagrid>

        </Fragment>
    );
};

export default JobList;
